var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncInc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0.75V2.75M3.75 14.75V16.75M0.75 2.75H5.75C6.54565 2.75 7.30871 3.06607 7.87132 3.62868C8.43393 4.19129 8.75 4.95435 8.75 5.75V5.893C8.75 6.65072 8.449 7.37741 7.9132 7.9132C7.37741 8.449 6.65072 8.75 5.893 8.75H0.75H5.75C6.54565 8.75 7.30871 9.06607 7.87132 9.62868C8.43393 10.1913 8.75 10.9544 8.75 11.75V11.893C8.75 12.6507 8.449 13.3774 7.9132 13.9132C7.37741 14.449 6.65072 14.75 5.893 14.75H0.75V2.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncInc);
export default __webpack_public_path__ + "static/media/icon_inc_inc.920a72823c86aec58166778d91146264.svg";
export { ForwardRef as ReactComponent };